export const scrollToPos = (position) => {
    return $('html, body')
        .animate({ scrollTop: position }, 'fast')
        .promise();
};

export const scrollToElement = ($element) => {
    const position = $element.offset().top - $('#topnav').height();

    if ($('body').scrollTop() !== position) {
        return scrollToPos(position);
    }
};

export const scrollToTop = () => scrollToPos(0);
